<template>
  <v-menu
    ref="menu"
    v-model="showMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="formattedDate"
        clearable
        readonly
        outlined
        :label="$t('share_links.expires')"
        v-bind="attrs"
        v-on="on"
        @click:clear="value = null">
      </v-text-field>
    </template>
    <v-date-picker
      v-model="vuetifyFormattedDate"
      scrollable
      :first-day-of-week="1"
      :locale="$t('app_info.locale')"
      @change="showMenu = false">
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      showMenu: false
    }
  },
  props: [ 'modelValue' ],
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  computed: {
    value: {
      get () {
        return this.modelValue
      },
      set (value) {
        this.$emit('update:modelValue', value)
      }
    },
    formattedDate () {
      return this.value ? moment(this.value).format('D.M.yyyy') : ''
    },
    vuetifyFormattedDate: {
      get: function () {
        return this.cvalue ? moment(this.value).format('yyyy-MM-DD') : ''
      },
      set: function (newValue) {
        this.value = moment(newValue).format()
        this.$emit('onChange')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shareLinks/ShareLinksDateEdit.vue